// import ContactSection from "../../components/ContactForm";
// import Header from "../../components/Header";

// import { motion } from 'framer-motion';
// import { Printer, FileCheck, Palette, CheckCircle, ArrowRight, Award, Clock, Shield } from 'lucide-react';

// import HeroSection from "../../components/HeroSection";
// import ServicesSection from "../../components/Services";
// import StepSection from "../../components/ServicesSection";
// import bannerImg from "../../assets/freepik__expand__64108.png"
// export default function PrePress() {
//   const fadeIn = {
//     initial: { opacity: 0, y: 20 },
//     animate: { opacity: 1, y: 0 },
//     transition: { duration: 0.6 }
//   };

//   const steps = [
//     {
//       icon: <FileCheck className="w-12 h-12 text-primary-base" />,
//       title: "File Preparation",
//       description: "We ensure that all your files are properly formatted, optimized, and ready for printing. This includes checking resolution, color mode, and image placement."
//     },
//     {
//       icon: <Palette className="w-12 h-12 text-primary-base" />,
//       title: "Color Management",
//       description: "Our expert color management ensures the correct color output in your final print. We work with various color profiles to make sure your prints are vibrant and consistent."
//     },
//     {
//       icon: <CheckCircle className="w-12 h-12 text-primary-base" />,
//       title: "Proofing & Approval",
//       description: "Before proceeding to production, we provide proofing services to make sure everything meets your expectations. Once approved, we move on to the next step in the process."
//     }
//   ];

//   const benefits = [
//     {
//       icon: <Award className="w-8 h-8" />,
//       title: "Quality Assurance",
//       description: "Guaranteed excellence in every print through rigorous quality control processes"
//     },
//     {
//       icon: <Clock className="w-8 h-8" />,
//       title: "Fast Turnaround",
//       description: "Quick and efficient service without compromising on quality"
//     },
//     {
//       icon: <Shield className="w-8 h-8" />,
//       title: "100% Satisfaction",
//       description: "We work until you're completely satisfied with the final result"
//     }
//   ];

//   const stepsData = [
//     {
//       title: "File Preparation",
//       description: "We ensure that all your files are properly formatted, optimized, and ready for printing. This step includes checking resolution, color mode, and image placement."
//     },
//     {
//       title: "Color Management",
//       description: "Our expert color management ensures the correct color output in your final print. We work with various color profiles to make sure your prints are vibrant and consistent."
//     },
//     {
//       title: "Proofing & Approval",
//       description: "Before proceeding to production, we provide proofing services to make sure everything meets your expectations. Once approved, we move on to the next step in the process."
//     }
//   ];
//   return (
//     <div className="font-body">
//       <Header />

//       {/* Hero Section */}
//       <section className="relative overflow-hidden bg-gradient-to-br from-primary-dark to-primary-base py-20 lg:py-32">
//         <div className="absolute inset-0 bg-grid-white/[0.2] bg-[size:16px]" />
//         <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <motion.div 
//             className="text-center"
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8 }}
//           >
//             <h1 className="text-5xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-8">
//               <span className="bg-clip-text text-transparent bg-gradient-to-r from-accent-base to-accent-light">
//                 Pre-Press Excellence
//               </span>
//             </h1>
//             <p className="text-xl text-neutral-200 max-w-2xl mx-auto mb-8">
//               Transform your designs into print-ready masterpieces with our professional pre-press services
//             </p>
//             <button className="bg-accent-base hover:bg-accent-light text-white font-bold py-4 px-8 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl">
//               Get Started Today
//             </button>
//           </motion.div>
//         </div>
//       </section>

//        {/* What is Pre-Press Section */}
//        <section className="py-20 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <motion.div 
//             className="text-center mb-15"
//             {...fadeIn}
//           >
//              <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary-base mb-4">
//             What is Pre-Press?
//           </h2>
//             <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//               Pre-Press is where precision meets creativity. It's the crucial phase where we transform your design files into print-ready perfection through advanced color management, meticulous file preparation, and comprehensive quality control.
//             </p>
//           </motion.div>
//         </div>
//       </section>
//        {/* Process Steps */}
//        <section className="py-20 bg-neutral-50">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary-base text-4xl font-bold text-center text-primary-base mb-16">
//             Our Pre-Press Process
//           </h2>
//           <div className="grid md:grid-cols-3 gap-8">
//             {steps.map((step, index) => (
//               <motion.div 
//                 key={index}
//                 className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: index * 0.2 }}
//               >
//                 <div className="mb-6">{step.icon}</div>
//                 <h3 className="text-2xl font-bold text-primary-base mb-4">{step.title}</h3>
//                 <p className="text-gray-600">{step.description}</p>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Benefits Section */}
//       <section className="py-20 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary-base text-4xl font-bold text-center text-primary-base mb-16">
//             Why Choose Our Pre-Press Services?
//           </h2>
//           <div className="grid md:grid-cols-3 gap-8">
//             {benefits.map((benefit, index) => (
//               <motion.div 
//                 key={index}
//                 className="p-6 rounded-xl bg-neutral-50 hover:bg-neutral-100 transition-colors duration-300"
//                 initial={{ opacity: 0, x: -20 }}
//                 animate={{ opacity: 1, x: 0 }}
//                 transition={{ delay: index * 0.2 }}
//               >
//                 <div className="flex items-center mb-4 text-primary-base">
//                   {benefit.icon}
//                   <h3 className="text-xl font-bold ml-3">{benefit.title}</h3>
//                 </div>
//                 <p className="text-gray-600">{benefit.description}</p>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//             {/* Call to Action */}
//             <section className="py-20 bg-gradient-to-br from-primary-dark to-primary-base text-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//           <h2 className="text-3xl md:text-5xl font-heading font-bold text-white text-4xl font-bold mb-8">Ready to Get Started?</h2>
//           <p className="text-xl mb-8 max-w-2xl mx-auto">
//             Let's transform your design into print-ready perfection. Our expert team is ready to help you achieve outstanding results.
//           </p>
//           <button className="bg-accent-base hover:bg-accent-light text-white font-bold py-4 px-8 rounded-lg transition-all duration-300 flex items-center mx-auto">
//             Contact Us Today
//             <ArrowRight className="ml-2 w-5 h-5" />
//           </button>
//         </div>
//       </section>

  

//       <ServicesSection />

//       {/* Contact Section */}
//       <ContactSection />
//     </div>
    
//   );
// }

import ContactSection from "../../components/ContactForm";
import Header from "../../components/Header";

import { motion } from 'framer-motion';
import { Printer, FileCheck, Palette, CheckCircle, ArrowRight, Award, Clock, Shield } from 'lucide-react';

import HeroSection from "../../components/HeroSection";
import ServicesSection from "../../components/Services";
import StepSection from "../../components/ServicesSection";
import bannerImg from "../../assets/Firefly 20250214075131.png";
import { Link, useLocation } from "react-router-dom";
import Footer from "../../components/Footer";
import { useEffect } from "react";



export default function DigitalPrinting() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  const steps = [
    {
      icon: <FileCheck className="w-12 h-12 text-primary-base" />,
      title: "File Setup",
      description: "We ensure that all your digital files are ready for printing. This includes checking resolution, file type, and proper design layout."
    },
    {
      icon: <Palette className="w-12 h-12 text-primary-base" />,
      title: "Color Precision",
      description: "Our digital printing service guarantees vibrant and consistent colors across all your prints. We use advanced color management techniques to ensure perfect color matching."
    },
    {
      icon: <CheckCircle className="w-12 h-12 text-primary-base" />,
      title: "Instant Proofing",
      description: "With digital printing, we can offer quick proofing, so you can review your design before the final print. Any adjustments are made fast and efficiently."
    }
  ];

  const benefits = [
    {
      icon: <Award className="w-8 h-8" />,
      title: "High-Quality Prints",
      description: "Guaranteed sharp, vibrant, and detailed digital prints with every project."
    },
    {
      icon: <Clock className="w-8 h-8" />,
      title: "Fast Turnaround",
      description: "Receive your prints quickly without compromising quality, perfect for tight deadlines."
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: "Eco-Friendly Printing",
      description: "Our digital printing process minimizes waste and uses eco-friendly inks and materials."
    }
  ];

  return (
    <div className="font-body">
      <Header />

      {/* Hero Section */}
      <section className="relative overflow-hidden bg-gradient-to-br from-primary-dark to-primary-base py-20 lg:py-32">
        <div className="absolute inset-0 bg-grid-white/[0.2] bg-[size:16px]" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div 
            className="text-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-5xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-8">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-accent-base to-accent-light">
                Digital Printing Excellence
              </span>
            </h1>
            <p className="text-xl text-neutral-200 max-w-2xl mx-auto mb-8">
              Bring your designs to life with our cutting-edge digital printing services. Fast, precise, and eco-friendly!
            </p>
            <Link to="/contact">
                <button className="bg-accent-base hover:bg-accent-light text-white font-bold py-4 px-8 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl">
                Get Started Today
                </button>
              </Link>
          </motion.div>
        </div>
      </section>

      {/* What is Digital Printing Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div 
            className="text-center mb-15"
            {...fadeIn}
          >
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary-base mb-4">
              What is Digital Printing?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Digital printing is the future of high-quality, fast, and cost-effective print solutions. Whether you're looking to print small runs or large batches, our digital printers produce stunning results with incredible precision.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Process Steps */}
      <section className="py-20 bg-neutral-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary-base text-4xl font-bold text-center text-primary-base mb-16">
            Our Digital Printing Process
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {steps.map((step, index) => (
              <motion.div 
                key={index}
                className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.2 }}
              >
                <div className="mb-6">{step.icon}</div>
                <h3 className="text-2xl font-bold text-primary-base mb-4">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </motion.div>
            ))}
          </div>
             {/* Image Section */}

        </div>
        
      </section>
      {/* Image Section */}


      {/* Benefits Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary-base text-4xl font-bold text-center text-primary-base mb-16">
            Why Choose Our Digital Printing Services?
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <motion.div 
                key={index}
                className="p-6 rounded-xl bg-neutral-50 hover:bg-neutral-100 transition-colors duration-300"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.2 }}
              >
                <div className="flex items-center mb-4 text-primary-base">
                  {benefit.icon}
                  <h3 className="text-xl font-bold ml-3">{benefit.title}</h3>
                </div>
                <p className="text-gray-600">{benefit.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

   


      {/* Call to Action */}
      <section className="py-20 bg-gradient-to-br from-primary-dark to-primary-base text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white text-4xl font-bold mb-8">Ready to Get Started?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Let’s bring your digital print projects to life with the highest quality and fastest turnaround.
          </p>
         
          <Link to="/contact">
          <button className="bg-accent-base hover:bg-accent-light text-white font-bold py-4 px-8 rounded-lg transition-all duration-300 flex items-center mx-auto">
            Contact Us Today
            <ArrowRight className="ml-2 w-5 h-5" />
          </button>
              </Link>
        </div>
      </section>

      <ServicesSection />

      {/* Contact Section */}
      <ContactSection />
      <Footer />
    </div>
  );
}
